<template>
  <div class="page-shell page-shell--enterprise-basic">
    <section class="page-shell__hero">
      <div class="page-shell__hero-main">
        <span class="page-shell__eyebrow">Enterprise Profile</span>
        <p class="page-shell__desc">
          维护企业基础资料与实名认证信息，保证联系人、地址和认证主体信息始终准确可用。
        </p>
        <div class="page-shell__stats">
          <div class="page-shell__stat">
            <strong>{{ enterpriseEdit && enterpriseEdit.name ? enterpriseEdit.name : '--' }}</strong>
            <span>企业名称</span>
          </div>
          <div class="page-shell__stat">
            <strong>{{ verifyInfo.verifyStep ? (infoMap[verifyInfo.verifyStep] || verifyInfo.verifyStep) : '未认证' }}</strong>
            <span>认证状态</span>
          </div>
          <div class="page-shell__stat">
            <strong>{{ activeTabLabel }}</strong>
            <span>当前分组</span>
          </div>
        </div>
      </div>
      <div class="page-shell__aside">
        <div class="page-shell__chips">
          <span class="page-shell__chip">基础资料</span>
          <span class="page-shell__chip">实名认证</span>
          <span class="page-shell__chip">企业档案</span>
        </div>
      </div>
    </section>

    <section class="page-shell__content">
      <div class="page-shell__panel page-shell__tabs">
        <div class="page-shell__panel-header">
          <div>
            <div class="page-shell__panel-title">企业设置</div>
            <div class="page-shell__panel-subtitle">
              按模块维护企业资料与认证信息，避免信息分散在多个页面。
            </div>
          </div>
        </div>
        <el-tabs v-model="activeName" class="customTabs" type="border-card">
          <el-tab-pane label="基础信息" name="detail">
            <el-card class="forms-containers apps-minContainer" style="padding: 0px;" shadow="never">
              <el-form ref="form" :model="enterpriseEdit" label-width="120px" :rules="rules">
                <el-alert style="margin-bottom: 16px" title="实名认证完成的企业不能进行名称的修改" v-if="enterpriseEdit.verify" type="success"/>
                <el-row>
                  <el-col :span="8">
                    <el-form-item prop="name" label="企业名称">
                      <el-input :disabled="enterpriseEdit.verify" v-model="enterpriseEdit.name"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="企业域">
                      <el-input disabled v-model="enterpriseEdit.domain"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row>
                  <el-col :span="8">
                    <el-form-item prop="contactName" label="联系人">
                      <el-input v-model="enterpriseEdit.contactName"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="contactPhone" label="联系电话">
                      <el-input v-model="enterpriseEdit.contactPhone"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="contactEmail" label="联系邮箱">
                      <el-input v-model="enterpriseEdit.contactEmail"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item prop="address" label="企业地址">
                      <el-input v-model="enterpriseEdit.address"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-button
                    v-permit="'Enterprise.Update'"
                    type="primary"
                    style="margin-left: 120px;"
                    @click="updateEnterprise"
                  >提交更新</el-button>
                </el-row>
              </el-form>
            </el-card>
          </el-tab-pane>
          <el-tab-pane v-permit="'Enterprise.Verify.Get'" label="实名认证" name="auth">
            <el-card class="forms-containers apps-minContainer" style="padding: 0px;" shadow="never">
              <el-alert
                v-if="verifyInfo.verifyStep"
                style="margin-bottom: 16px;"
                :title="infoMap[verifyInfo.verifyStep]||''"
                :type="verifyInfo.verifyStep==='reject'?'warning':'success'"
              ></el-alert>
              <el-form ref="verifyform" :model="verifyInfo" label-width="120px" :rules="verifyRules">
                <el-row>
                  <el-col :span="8">
                    <el-form-item prop="socialCode" label="社会信用代码">
                      <el-input
                        :disabled="verifyInfo.verifyStep == 'pass'"
                        v-model="verifyInfo.socialCode"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item prop="corporate" label="企业法人">
                      <el-input
                        :disabled="verifyInfo.verifyStep == 'pass'"
                        v-model="verifyInfo.corporate"
                      ></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item ref="uploadpic" prop="licenseImagePath" label="营业执照">
                      <el-upload
                        :disabled="verifyInfo.verifyStep == 'pass'"
                        class="avatar-uploader"
                        :action="uploadConfig.api"
                        :with-credentials="true"
                        :headers="uploadConfig.headers"
                        :show-file-list="false"
                        :on-success="handleAvatarSuccess"
                        :on-error="handleAvatarError"
                        :before-upload="beforeAvatarUpload"
                      >
                        <img
                          v-if="verifyInfo.licenseImagePath && verifyInfo.licenseImagePath.length>0"
                          :src="verifyInfo.licenseImagePath[0]"
                          class="avatar"
                        />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-button
                    v-permit="'Enterprise.Verify.Commit'"
                    v-if="verifyInfo.verifyStep == 'created'"
                    type="primary"
                    style="margin-left: 120px;"
                    @click="verifyEnterprise"
                  >更新信息</el-button>
                  <el-button
                    v-permit="'Enterprise.Verify.Commit'"
                    v-else-if="verifyInfo.verifyStep != 'pass'"
                    type="primary"
                    style="margin-left: 120px;"
                    @click="verifyEnterprise"
                  >实名认证</el-button>
                </el-row>
              </el-form>
            </el-card>
          </el-tab-pane>
        </el-tabs>
      </div>
    </section>
  </div>
</template>
<script>
import { getToken } from '@/utils/auth';
import { errorHandle } from '../../../utils/error';
import {
  updateEnterprise,
  fetchEnterpriseVerifyInfo,
  verifyEnterprise
} from '@/api/enterpriseManage';
export default {
  name: 'Basic',
  data() {
    var baseDomain = process.env.BASE_API;
    if (baseDomain == '/') {
      baseDomain = window.location.origin;
    }
    return {
      infoMap: {
        created: '实名认证信息已申请，在审批通过前你可以继续修改信息',
        pass: '已完成实名认证',
        reject: '实名认证未通过，请重新申请'
      },
      Loading: true,
      activeName: 'detail',
      enterpriseEdit: {
        name: ''
      },
      verifyInfo: {
        licenseImagePath: null
      },
      uploadConfig: {
        api: `${baseDomain}/app-server/uploads/picture`,
        headers: {
          Authorization: getToken()
        }
      },
      verifyRules: {
        socialCode: [
          { required: true, message: '社会信用代码是必填', trigger: 'blur' },
          {
            min: 18,
            max: 18,
            message: '社会信用代码只能是18位',
            trigger: 'blur'
          }
        ],
        corporate: [
          { required: true, message: '企业法人是必填', trigger: 'blur' },
          {
            min: 2,
            max: 255,
            message: '企业法人长度不符合规范',
            trigger: 'blur'
          }
        ],
        licenseImagePath: [
          { required: true, message: '必须上传营业执照', trigger: 'blur' }
        ]
      },
      rules: {
        name: [
          { required: true, message: '企业名称是必填', trigger: 'blur' },
          {
            min: 2,
            max: 255,
            message: '企业名称字符在2-255之间',
            trigger: 'blur'
          }
        ],
        contactName: [
          { required: true, message: '联系人是必填', trigger: 'blur' },
          {
            min: 2,
            max: 255,
            message: '联系人字符在2-255之间',
            trigger: 'blur'
          }
        ],
        contactPhone: [
          { required: true, message: '联系电话是必填', trigger: 'blur' },
          {
            pattern: /^\d{11}$/,
            message: '联系电话只能是11位、只能由数字组成',
            trigger: 'blur'
          }
        ],
        contactEmail: [
          { required: true, message: '联系邮箱是必填', trigger: 'blur' },
          { type: 'email', message: '联系邮箱不符合规范', trigger: 'blur' }
        ],
        address: [
          {
            min: 2,
            max: 255,
            message: '联系地址字符在2-255之间',
            trigger: 'blur'
          }
        ]
      }
    };
  },
  created() {
    const initTab = this.$route.query.tab;
    if (initTab) {
      this.activeName = initTab;
    }
    this.enterpriseEdit = this.enterprise;
    this.getEnterpriseVerifyInfo();
  },
  computed: {
    sidebar() {
      return this.$store.state;
    },
    enterprise() {
      return this.$store.state.enterprise.enterpriseInfo;
    },
    activeTabLabel() {
      const map = {
        detail: '基础信息',
        auth: '实名认证'
      };
      return map[this.activeName] || '企业设置';
    }
  },
  methods: {
    getEnterpriseVerifyInfo() {
      fetchEnterpriseVerifyInfo(this.enterprise.eid).then((re) => {
        this.verifyInfo = re;
      });
    },
    updateEnterprise() {
      const formName = 'form';
      this.$refs[formName].validate((valid) => {
        if (valid) {
          updateEnterprise(this.enterpriseEdit)
            .then((re) => {
              this.$store.dispatch('GetEnterpriseInfo', this.enterpriseEdit.eid)
              this.$message.success('更新成功');
            })
            .catch((err) => {
              errorHandle(err);
            });
        }
      });
    },
    verifyEnterprise() {
      const formName = 'verifyform';
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let message = '申请成功';
          if (this.verifyInfo.verifyStep == 'created') {
            message = '更新成功';
          }
          this.verifyInfo.eid = this.enterprise.eid;
          verifyEnterprise(this.verifyInfo)
            .then((re) => {
              this.$message.success(message);
              this.getEnterpriseVerifyInfo();
            })
            .catch((err) => {
              errorHandle(err);
            });
        }
      });
    },
    handleAvatarSuccess(res, file) {
      this.verifyInfo.licenseImagePath = [res.FileURL];
    },
    handleAvatarError(re) {
      if (re.code == 10024) {
        this.$message.error(
          '上传图片类型不支持，请上传以.png .jpg .jpeg 结尾的图片'
        );
        return;
      }
      this.$message.error('上传失败!');
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPng) {
        this.$message.error('上传头像图片只能是 JPG、PNG格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return (isJPG || isPng) && isLt2M;
    },
    beforeAvatarUploadpic(file) {
      const isJPG = file.type === 'image/jpeg';
      const isPng = file.type === 'image/png';
      const isLt2M = file.size / 1024 / 1024 < 200;

      if (!isJPG && !isPng) {
        return this.$message.error('上传图片只能是 JPG、PNG格式!');
      }
      if (!isLt2M) {
        return this.$message.error('上传图片大小不能超过 200MB!');
      }

      return (isJPG || isPng) && isLt2M;
    }
  }
};
</script>
<style lang="scss" scoped>
@import 'src/styles/page-shell.scss';

.avatar-uploader {
  width: 350px;
  height: 175px;
  border-radius: 10px;
  border: 2px dashed #f0f0f0;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 350px;
  height: 175px;
  line-height: 175px;
  text-align: center;
}
.avatar {
 width: 350px;
  height: 175px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/information/basic/index.vue